module.exports = __webpack_public_path__ + "img/business-coin-placeholder.d63ff579.svg";